import colors from '@mathflat/common/style/colors'
import * as React from 'react'

import type { StyleProps } from '@/types'

import S from './Divider.style'

type Props = {
  type?: 'vertical' | 'horizontal'
  size?: number | string
  margin?: number
  borderWidth?: number
  color?: string
} & StyleProps

const Divider = ({
  type = 'vertical',
  size = 30,
  margin = 12,
  borderWidth = 1,
  color = colors.gray.$400,
  className,
  style,
}: Props) => {
  return (
    <div
      className={className}
      css={[S.basic]}
      style={{ ...S.type[type](size, margin, borderWidth, color), ...style }}
    />
  )
}

export default React.memo(Divider)
